





























































































































































































































































































import { Forbidden } from '@/api/responses/forbidden';
import { TaskApi } from '@/api/task';
import loading from '@/components/loading.vue';
import assignTaskDialog from '@/components/tasks/task-list/assign-task-dialog.vue';
import completeTaskDialog from '@/components/tasks/task-list/complete-task-dialog.vue';
import editTaskDialog from '@/components/tasks/task-list/edit-task-dialog.vue';
import tasksTable from '@/components/tasks/task-list/tasks-table.vue';
import layout from '@/layouts/app.vue';
import { PartnerPractice } from '@/shared/partner-practice';
import { TaskItem } from '@/shared/task-item';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');

const taskApi = new TaskApi();

@Component({
    components: {
        layout,
        tasksTable,
        assignTaskDialog,
        completeTaskDialog,
        editTaskDialog,
        loading,
    },
})
export default class Tasks extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;

    private isLoading: boolean = true;
    private currentPage: number = 1;
    private pageSize: number = 20;
    private total: number = 0;
    private tasks: Array<TaskItem> = new Array<TaskItem>();
    private partnerPracticeFilter: string | null = null;
    private originalSourceFilter: string | null = null;
    private accountNumberFilter: number | null = null;
    private clientNameFilter: string | null = null;
    private createdDatePeriodFilter: number | null = null;
    private createdDateFromFilter: string | Date | null = null;
    private createdDateToFilter: string | Date | null = null;
    private appointmentDatePeriodFilter: number | null = null;
    private appointmentDateFromFilter: string | Date | null = null;
    private appointmentDateToFilter: string | Date | null = null;
    private dueDateFilter: string | Date | null = new Date();
    private typeFilter: number | null = null;
    private statusFilter: number | null = 0;
    private assignedUserFilter: string | null = null;
    private completedByFilter: string | null = null;
    private completedDatePeriodFilter: number | null = null;
    private completedDateFromFilter: string | Date | null = null;
    private completedDateToFilter: string | Date | null = null;
    private completeTaskDialogVisible: boolean = false;
    private editTaskDialogVisible: boolean = false;
    private deleteTaskConfirmationDialogVisible: boolean = false;
    private assignTasksDialogVisible: boolean = false;
    private selectedTask: TaskItem | null = null;
    private selectedTasks: Array<TaskItem & { selected: boolean }> = new Array<TaskItem & { selected: boolean }>();

    private datePeriods = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Current Day' },
        { id: 1, value: 'Current Week' },
        { id: 2, value: 'Previous Week' },
        { id: 3, value: 'Current Month' },
        { id: 4, value: 'Previous Month' },
        { id: 5, value: 'Current Quarter' },
        { id: 6, value: 'Previous Quarter' },
        { id: 7, value: 'Current Year' },
        { id: 8, value: 'Previous Year' },
        { id: 9, value: 'Custom Dates' },
    ]);

    private taskTypes = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Retrieve Will Packet' },
        { id: 1, value: 'Send Confirmation Letter' },
    ]);

    private taskStatuses = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Pending' },
        { id: 1, value: 'Completed' },
        { id: 2, value: 'Overdue' },
        { id: 3, value: 'Actioned' },
        { id: 4, value: 'Not Actioned' },
    ]);

    private get isCustomCreatedDateFilter(): boolean {
        return this.createdDatePeriodFilter === 9;
    }

    private get isCustomAppointmentDateFilter(): boolean {
        return this.appointmentDatePeriodFilter === 9;
    }

    private get isCustomCompletedDateFilter(): boolean {
        return this.completedDatePeriodFilter === 9;
    }

    @Watch('completedDatePeriodFilter')
    private async onCompletedDatePeriodFilterChanged(): Promise<void> {
        this.completedDateFromFilter = null;
        this.completedDateToFilter = null;
    }

    private async loadTasksAsync(): Promise<void> {
        if (!(await this.$validator.validateAll())) { return; }

        this.isLoading = true;
        await this.fetchAllTasksAsync();
        this.isLoading = false;
    }

    private async fetchAllTasksAsync(): Promise<void> {
        try {
            const result = await taskApi.getTasksAsync({
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
                type: this.typeFilter,
                accountNumber: this.accountNumberFilter,
                clientName: this.clientNameFilter,
                partnerPracticeId: this.partnerPractices.length === 1 ? this.partnerPractices[0].id! : this.partnerPracticeFilter,
                originalSourceId: this.originalSourceFilter,
                createdDatePeriod: this.createdDatePeriodFilter,
                createdDateFrom: this.createdDateFromFilter,
                createdDateTo: this.createdDateToFilter,
                appointmentDatePeriod: this.appointmentDatePeriodFilter,
                appointmentDateFrom: this.appointmentDateFromFilter,
                appointmentDateTo: this.appointmentDateToFilter,
                dueDate: this.dueDateFilter,
                status: this.statusFilter,
                assignedTo: this.assignedUserFilter,
                completedById: this.completedByFilter,
                completedDatePeriod: this.completedDatePeriodFilter,
                completedDateFrom: this.completedDateFromFilter,
                completedDateTo: this.completedDateToFilter,
            });

            this.tasks = result.tasks;
            this.total = result.total;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not load tasks.', type: 'is-danger' });
            }
        }
    }

    private clearFilters(): void {
        this.partnerPracticeFilter = null;
        this.originalSourceFilter = null;
        this.accountNumberFilter = null;
        this.clientNameFilter = null;
        this.createdDatePeriodFilter = null;
        this.createdDateFromFilter = null;
        this.createdDateToFilter = null;
        this.appointmentDatePeriodFilter = null;
        this.appointmentDateFromFilter = null;
        this.appointmentDateToFilter = null;
        this.dueDateFilter = new Date();
        this.typeFilter = null;
        this.statusFilter = 0;
        this.assignedUserFilter = null;
        this.completedByFilter = null;
        this.completedDatePeriodFilter = null;
        this.completedDateFromFilter = null;
        this.completedDateToFilter = null;

        this.$validator.reset();
    }

    private async onPageChanged(value: number): Promise<void> {
        this.currentPage = value;

        this.isLoading = true;
        await this.fetchAllTasksAsync();
        this.isLoading = false;
    }

    private showAssignTasksDialog(tasks: Array<TaskItem & { selected: boolean }>): void {
        this.selectedTasks = tasks;
        this.assignTasksDialogVisible = true;
    }

    private showCompleteTaskDialog(task: TaskItem): void {
        this.selectedTask = task;
        this.completeTaskDialogVisible = true;
    }

    private showEditTaskDialog(task: TaskItem): void {
        this.selectedTask = task;
        this.editTaskDialogVisible = true;
    }

    private showDeleteTaskConfirmation(task: TaskItem): void {
        this.selectedTask = task;
        this.deleteTaskConfirmationDialogVisible = true;
    }

    private async onTaskCompleted(): Promise<void> {
        this.$snackbar.open({ message: `Task successfully completed`, type: 'is-success' });
        this.onCancel();

        this.isLoading = true;
        await this.loadTasksAsync();
        this.isLoading = false;
    }

    private async onTaskUpdated(): Promise<void> {
        this.$snackbar.open({ message: `Task successfully updated`, type: 'is-success' });
        this.onCancel();

        this.isLoading = true;
        await this.loadTasksAsync();
        this.isLoading = false;
    }

    private async onTaskDeleted(): Promise<void> {
        try {
            await taskApi.deleteTaskAsync(this.selectedTask!);
        } catch (e) {
            this.$snackbar.open({ message: `Could not delete task, please try again.`, type: 'is-danger' });
        }

        this.onCancel();

        this.isLoading = true;
        await this.loadTasksAsync();
        this.isLoading = false;
    }

    private async onTasksAssigned(): Promise<void> {
        this.$snackbar.open({ message: `Task(s) successfully assigned`, type: 'is-success' });
        this.onCancel();

        this.isLoading = true;
        await this.loadTasksAsync();
        this.isLoading = false;
    }

    private async onTasksUnassigned(tasks: Array<TaskItem & { selected: boolean }>): Promise<void> {
        try {
            const unassign = tasks.filter((task) => task.users.length > 0);
            const promises = unassign.map((task) => taskApi.assignTaskAsync(task.id!, []));
            await Promise.all(promises);

            this.$snackbar.open({ message: `Task(s) successfully unassigned.`, type: 'is-success' });
        } catch (e) {
            this.$snackbar.open({ message: `Could not unassign task(s), please try again.`, type: 'is-danger' });
        }

        this.onCancel();

        this.isLoading = true;
        await this.fetchAllTasksAsync();
        this.isLoading = false;
    }

    private onCancel(): void {
        this.selectedTask = null;
        this.completeTaskDialogVisible = false;
        this.editTaskDialogVisible = false;
        this.assignTasksDialogVisible = false;
        this.deleteTaskConfirmationDialogVisible = false;
    }

    public async mounted(): Promise<void> {
        this.isLoading = true;

        await Promise.all([
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`types/loadPartnerPracticeTypesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        if (this.partnerPractices.length === 1) {
            await this.fetchAllTasksAsync();
        }

        this.isLoading = false;
    }
}
